export const MESSAGING_THREADS_PATH = '/v1/messaging-threads';
export const MESSAGING_THREADS_PATH_V2 = '/v2/messaging-threads';
export const GET_MESSAGING_CONTACTS_PATH = '/v1/messaging-contacts';
export const THREAD_MESSAGES_PATH = '/v1/thread-messages';
export const MESSAGING_CONFIG_PATH = '/v1/messaging-configs';
export const GENERATE_QUESTIONNAIRE_PATH = '/v1/generate-questionnaire';
export const QUESTIONNAIRE_RESPONSE_PATH = '/v1/questionnaire-response';
export const NEXT_QUESTIONNAIRE_PATH = '/v1/next';
export const POST_START_ASYNC_MESSAGING = '/v1/async-message';
